import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/InvoiceList.vue"),
    meta: {
      accessLevel: "super",
      title: "Invoices",
    },
    name: "invoices",
    path: "/invoices",
    props: (route) => typecastRouteProps(route),
  },
];
